<template>
    <router-link :to="project.link" :title="project.title" class="clean" >
        <div class="uk-card uk-card-default uk-box-shadow-hover-large uk-margin-small-bottom uk-position-relative card-project-row">
            
            <div class="uk-card-badge uk-label uk-hidden@m uk-position-absolute uk-position-top-right" v-if="project?.category.id > 0">{{project.category.title}}</div>

            <div class="uk-grid-collapse" uk-grid >
                <div class="uk-width-1-5">
                    <div class="uk-card-media uk-position-relative">
                        <div class="ar4x3 uk-background-cover" v-bind:style="{ backgroundImage: `url(${project.image.smallSquare})` }" :alt="project.title"></div>
                        <div class="uk-card-badge uk-label uk-card-badge-visible-medium uk-visible@m" v-if="project?.category.id > 0">{{project.category.title}}</div>
                        <div class="uk-position-absolute uk-position-top-right uk-position-small uk-text-primary card-project__featured-badge" v-if="project.featured" style="z-index:10000">
                            <i uk-icon="icon: star; ratio: 1.1" />
                        </div>
                    </div>
                </div>
                <div class="uk-width-4-5 uk-width-3-5@m">
                    <div class="uk-card-body uk-text-left">
                        <div class="match-height">
                            <h3 class="uk-card-title uk-margin-small-bottom">{{project.title}}</h3>
                            <p class="summary uk-visible@s uk-margin-remove">{{project.summary}}</p>
                        </div>
                    </div>
                </div>
                <div class="uk-position-absolute uk-position-center-right uk-visible@m">
                    <span class="uk-button uk-button-primary uk-margin-remove">View</span>
                </div>
            </div>
        </div>
    </router-link>
</template>

<script>
export default {
    props: ['project']
}
</script>
